



















import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetAssayStatistics, GetCommonAssayStatistics} from "@/api/report"
import {GetDicsByCode} from "@/api/systemBasic"
import {GetListByCode} from "@/api/configureDictionary"

@Component
export default class Assay extends AbpBase{
	loading = false
	data:any = []
	isTemp = "全部"
	dates:any =[]
	PatTag:any =[]
	tags:any =[]
	columns:any = [
		{
			title: '时间',
			key: 'date'
		},
		{
			title: '总数',
			key: 'count'
		},
		{
			title: '达标数',
			key: 'standardCount'
		},
		{
			title: '不达标数',
			key: 'unStandardCount'
		},
		{
			title: '超标数',
			key: 'upStandardCount'
		}
	]
	options = {
		shortcuts: [
			{
				text: '一个月',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
					return [start, end];
				}
			},
			{
				text: '三个月',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
					return [start, end];
				}
			}
		]
	}
	async created(){
		await this.getSelects()
		this.dates = this.getMonthStartAndEnd()
		this.getData()
	}
	dateChange(e:any){
		this.dates = e
		this.getData()
	}
	async getData(){
		this.loading = true
		let query:any = {
			StartDate: this.dates[0],
			EndDate: this.dates[1],
			PatTag: this.PatTag.join(';')
		}
		switch (this.isTemp) {
			case "非临时患者":
				query.IsTemp = false
				break
			case "临时患者":
				query.IsTemp = true
				break
		}
		let res = await GetAssayStatistics(query)
		this.data = res.objects.assayStatisticItem
		this.loading = false
	}

	private async getSelects() {
		let res = await GetDicsByCode({code: 'tag'})
		this.tags = res.objects
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/assay/index.vue